import HookLoader from './HookLoader/HookLoader';
import useFetch from './useFetch';
import { DEVURL, PPURL, SITURL, SIT2URL } from '../constants';

const win: any = window;
const baseUrl = window.location.origin.includes('localhost') ? "http://ssta004:8080" : window.location.origin;

interface Props {
    setEnv: React.Dispatch<React.SetStateAction<boolean>>;
}

const ResourceEnvironment = ({ setEnv }: Props) => {
    let utilUrl = baseUrl;

    if (baseUrl.includes('apisit')) {
        utilUrl = SITURL;
    } else if (baseUrl.includes('apipreprod')) {
        utilUrl = PPURL;
    } else if (baseUrl.includes('apidev')) {
        utilUrl = DEVURL;
    } else if (baseUrl.includes('apisit2')) {
        utilUrl = SIT2URL;
    }

    const url = `${utilUrl}/mobilyTheme4/BzFvwmzXvs`;
    const req = { "data": "CEM_KEY~APIGEE_BASE_URL" };
    const { response, loading }: any = useFetch(url, req, setEnv);
    //console.log("ResourceEnvironment", response)

    if (response) {
        !!!win["CEM_KEY"] && (win["CEM_KEY"] = response.CEM_KEY);
        !!!win["base_api_url"] && (win["base_api_url"] = response.APIGEE_BASE_URL);
        !!!win["errorPageURL"] && (win["errorPageURL"] = '/wps/portal/web/personal/store/error');
        !!!win["successPageURL"] && (win["successPageURL"] = 'confirmation');
    }

    return (
        <div>
            {loading && <HookLoader loading={loading} />}
        </div>
    )
}

export default ResourceEnvironment